const defaultConfig = {
	fontFamily: ['Roboto', 'sans-serif'].join(','),
};
export default defaultConfig;
